import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';
import { CategoryService } from '@core/services-v2/category/services/category.service';
import {
  FirstLevelMenuItem,
  ThirdLevelMenuItem,
  SecondLevelMenuItem,
} from 'src/app/modules/header/components/menu-categorias-b2c/models';

@Component({
  selector: 'app-filtro-categorias',
  templateUrl: './filtro-categorias.component.html',
})
export class FiltroCategoriasComponent implements OnInit {
  categorias: FirstLevelMenuItem[] = [];
  categoria2: SecondLevelMenuItem[] = [];
  categoria3: ThirdLevelMenuItem[] = [];
  level1: string | null = null;
  level2: string | null = null;
  level3: string | null = null;
  @Output() url: EventEmitter<string | null> = new EventEmitter();

  private readonly categoryService: CategoryService = inject(CategoryService);

  async ngOnInit() {
    this.obtenerCategorias();
  }

  private obtenerCategorias(): void {
    this.categoryService.getMenuCategories().subscribe({
      next: (categories) => {
        this.categorias = categories.items;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  changeSelect() {
    this.categoria2 = [];
    this.categoria3 = [];
    if (this.level1) {
      const consulta: FirstLevelMenuItem[] = this.categorias.filter(
        (item) => item.slug === this.level1
      );
      this.categoria2 = consulta[0].items;
    } else {
      this.level2 = null;
      this.level3 = null;
    }
  }

  changeSelect2() {
    this.categoria3 = [];

    if (!this.level2) {
      this.level3 = null;
    } else {
      const consulta: SecondLevelMenuItem[] = this.categoria2.filter(
        (item) => item.slug === this.level2
      );
      this.categoria3 = consulta[0].items;
    }
  }

  Filtrar() {
    if (this.level2 && this.level3) this.url.emit(this.level3);
    else if (this.level2 && !this.level3) this.url.emit(this.level2);
    else if (!this.level2 && !this.level3) this.url.emit(this.level1);
  }
}
